
import React, { useState, useEffect } from "react";
import { useAuth } from "./context/AuthContext";
import { Eye, EyeOff } from "lucide-react";

export function Login({ bootErr }: { bootErr?: any }) {
  const { login } = useAuth();
  
  const [email, setEmail] = useState("kc"); // Default simplified
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("[Login] Loaded v1: LegalOps Platform (Standard)");
  }, []);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      // Use context login to handle normalization and auto-create
      await login(email, password);
      // Success will trigger AuthContext update, App.tsx will switch view.
    } catch (err: any) {
      console.error(err);
      const code = err?.code ? ` (${err.code})` : "";
      setError("登入失敗" + code + ": " + (err.message || "未知錯誤"));
    } finally {
      setLoading(false);
    }
  };

  if (bootErr) {
    return (
      <div style={{ padding: 40, color: "#f87171", background: "#000", minHeight: "100vh", fontFamily: "monospace" }}>
        <h2 style={{marginTop:0}}>Startup Error</h2>
        <pre style={{background:"#111", padding:20, overflow:"auto"}}>{JSON.stringify(bootErr, null, 2)}</pre>
      </div>
    );
  }

  return (
    <div style={{
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center", 
      height: "100vh", 
      width: "100vw",
      background: "#050505",
      color: "#e5e5e5",
      fontFamily: "var(--font-sans, system-ui, sans-serif)"
    }}>
      <div className="login-card" style={{ 
          width: 360, 
          padding: "40px 32px", 
          background: "#121212", 
          border: "1px solid #333", 
          borderRadius: 16,
          boxShadow: "0 20px 60px rgba(0,0,0,0.5)"
      }}>
        <div style={{textAlign:'center', marginBottom: 32}}>
            <h2 style={{ margin: "0 0 8px 0", color: "#fff", fontSize: 22, fontWeight: 700 }}>LegalOps Platform</h2>
            <div style={{fontSize: 13, color: "#888"}}>請登入以進入系統 (Firebase Auth)</div>
        </div>
        
        <form onSubmit={handleLogin}>
          <div style={{marginBottom: 20}}>
            <label style={{display:'block', marginBottom: 8, fontSize: 13, color: '#aaa', fontWeight: 500}}>Email / 帳號</label>
            <input 
              type="text" 
              value={email} 
              onChange={e => setEmail(e.target.value)}
              style={{
                  width: '100%', 
                  padding: '12px', 
                  background: "#000", 
                  border: "1px solid #333", 
                  color: "#fff", 
                  borderRadius: 8,
                  fontSize: 14,
                  outline: "none"
              }}
              placeholder="e.g. kc or name@company.com"
            />
          </div>
          
          <div style={{marginBottom: 24}}>
            <label style={{display:'block', marginBottom: 8, fontSize: 13, color: '#aaa', fontWeight: 500}}>密碼 (Password)</label>
            <div style={{position: 'relative'}}>
              <input 
                type={showPassword ? "text" : "password"}
                value={password} 
                onChange={e => setPassword(e.target.value)}
                style={{
                    width: '100%', 
                    padding: '12px', 
                    paddingRight: '40px', // Space for eye icon
                    background: "#000", 
                    border: "1px solid #333", 
                    color: "#fff", 
                    borderRadius: 8,
                    fontSize: 14,
                    outline: "none"
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: 10,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  color: '#666',
                  cursor: 'pointer',
                  padding: 4,
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <button 
            type="submit" 
            style={{ 
                width: "100%", 
                padding: '12px', 
                background: "#fff", 
                color: "#000", 
                fontWeight: 600, 
                border: "none", 
                borderRadius: 8, 
                cursor: loading ? "not-allowed" : "pointer",
                fontSize: 14,
                transition: "opacity 0.2s"
            }} 
            disabled={loading}
          >
            {loading ? "登入中..." : "登入 (Sign in)"}
          </button>

          {error && (
            <div style={{ marginTop: 16, color: '#f87171', fontSize: 13, background: 'rgba(239,68,68,0.1)', padding: 12, borderRadius: 8, border: "1px solid rgba(239,68,68,0.2)", textAlign: 'center', wordBreak: 'break-all' }}>
              {error}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
